import type { Location, Inquiry, Country } from "@/types/constants_type";

export const locations: Location[] = [
  {
    id: 0,
    headquarters: "global",
    name: "Global",
    company: "ECQ Global PTE., LTD",
    address: "33 Ubi Avenue 3, Vertex Tower A, #08-51, Singapore, 408868",
    phone: "+65 6680 9321",
    phoneNumber: "6566809321",
    mail: "",
  },
  {
    id: 1,
    headquarters: "th",
    name: "Thailand",
    company: "E-CQURITY (Thailand) CO., LTD",
    address:
      "1032/136 - 138 Paholyothin 18/1 Rd., Chomphon, Chatuchak Bangkok 10900 Thailand",
    phone: "+66 2165 0258",
    phoneNumber: "6621650258",
    mail: "sales.th@e-cq.net",
  },
  {
    id: 2,
    headquarters: "sg",
    name: "Singapore",
    // The registered name, exactly as filed: no "(Singapore)", and the comma
    // belongs after neither PTE nor LTD. Don't "tidy" this string.
    company: "E-CQURITY PTE. LTD.",
    address: "33 Ubi Avenue 3, Vertex Tower A, #08-51, Singapore, 408868",
    phone: "+65 6680 9321",
    phoneNumber: "6566809321",
    mail: "hr.sg@e-cq.net",
  },
  {
    id: 3,
    headquarters: "vn",
    name: "Vietnam",
    company: "E-CQURITY (Vietnam) CO., LTD",
    // Ward, then city — no district. Ho Chi Minh City's district level was
    // dissolved in the 2025 administrative merger, and the old "Ward 7, Binh
    // Thanh District" became Gia Dinh Ward, which now reports straight to the
    // city. Don't re-insert a district line to make this match the other
    // offices' shape.
    address:
      "8Bis Hoang Hoa Tham Street, Gia Dinh Ward, Ho Chi Minh City, Vietnam",
    phone: "+84 286 2727 704",
    phoneNumber: "84 2862727704",
    mail: "hr.vn@e-cq.net",
  },
];

export const inquiries: Inquiry[] = [
  {
    name: "Human Resources",
    key: "hr",
  },
  {
    name: "Sale",
    key: "sales",
  },
];

export const countries: Country[] = [
  { value: "afghanistan", label: "Afghanistan" },
  { value: "albania", label: "Albania" },
  { value: "algeria", label: "Algeria" },
  { value: "american-samoa", label: "American Samoa" },
  { value: "andorra", label: "Andorra" },
  { value: "angola", label: "Angola" },
  { value: "anguilla", label: "Anguilla" },
  { value: "antarctica", label: "Antarctica" },
  { value: "antigua-and-barbuda", label: "Antigua and Barbuda" },
  { value: "argentina", label: "Argentina" },
  { value: "armenia", label: "Armenia" },
  { value: "aruba", label: "Aruba" },
  { value: "australia", label: "Australia" },
  { value: "austria", label: "Austria" },
  { value: "azerbaijan", label: "Azerbaijan" },
  { value: "bahamas", label: "Bahamas" },
  { value: "bahrain", label: "Bahrain" },
  { value: "bangladesh", label: "Bangladesh" },
  { value: "barbados", label: "Barbados" },
  { value: "belarus", label: "Belarus" },
  { value: "belgium", label: "Belgium" },
  { value: "belize", label: "Belize" },
  { value: "benin", label: "Benin" },
  { value: "bermuda", label: "Bermuda" },
  { value: "bhutan", label: "Bhutan" },
  { value: "bolivia", label: "Bolivia (Plurinational State of)" },
  {
    value: "bonaire-sint-eustatius-and-saba",
    label: "Bonaire, Sint Eustatius and Saba",
  },
  { value: "bosnia-and-herzegovina", label: "Bosnia and Herzegovina" },
  { value: "botswana", label: "Botswana" },
  { value: "bouvet-island", label: "Bouvet Island" },
  { value: "brazil", label: "Brazil" },
  {
    value: "british-indian-ocean-territory",
    label: "British Indian Ocean Territory",
  },
  { value: "brunei-darussalam", label: "Brunei Darussalam" },
  { value: "bulgaria", label: "Bulgaria" },
  { value: "burkina-faso", label: "Burkina Faso" },
  { value: "burundi", label: "Burundi" },
  { value: "cabo-verde", label: "Cabo Verde" },
  { value: "cambodia", label: "Cambodia" },
  { value: "cameroon", label: "Cameroon" },
  { value: "canada", label: "Canada" },
  { value: "cayman-islands", label: "Cayman Islands" },
  { value: "central-african-republic", label: "Central African Republic" },
  { value: "chad", label: "Chad" },
  { value: "chile", label: "Chile" },
  { value: "china", label: "China" },
  { value: "christmas-island", label: "Christmas Island" },
  { value: "cocos-islands", label: "Cocos (Keeling) Islands" },
  { value: "colombia", label: "Colombia" },
  { value: "comoros", label: "Comoros" },
  {
    value: "congo-democratic-republic",
    label: "Congo (the Democratic Republic of the)",
  },
  { value: "congo", label: "Congo" },
  { value: "cook-islands", label: "Cook Islands" },
  { value: "costa-rica", label: "Costa Rica" },
  { value: "croatia", label: "Croatia" },
  { value: "cuba", label: "Cuba" },
  { value: "curaçao", label: "Curaçao" },
  { value: "cyprus", label: "Cyprus" },
  { value: "czechia", label: "Czechia" },
  { value: "cote-divoire", label: "Côte d'Ivoire" },
  { value: "denmark", label: "Denmark" },
  { value: "djibouti", label: "Djibouti" },
  { value: "dominica", label: "Dominica" },
  { value: "dominican-republic", label: "Dominican Republic" },
  { value: "ecuador", label: "Ecuador" },
  { value: "egypt", label: "Egypt" },
  { value: "el-salvador", label: "El Salvador" },
  { value: "equatorial-guinea", label: "Equatorial Guinea" },
  { value: "eritrea", label: "Eritrea" },
  { value: "estonia", label: "Estonia" },
  { value: "eswatini", label: "Eswatini" },
  { value: "ethiopia", label: "Ethiopia" },
  { value: "falkland-islands", label: "Falkland Islands [Malvinas]" },
  { value: "faroe-islands", label: "Faroe Islands" },
  { value: "fiji", label: "Fiji" },
  { value: "finland", label: "Finland" },
  { value: "france", label: "France" },
  { value: "french-guiana", label: "French Guiana" },
  { value: "french-polynesia", label: "French Polynesia" },
  {
    value: "french-southern-territories",
    label: "French Southern Territories",
  },
  { value: "gabon", label: "Gabon" },
  { value: "gambia", label: "Gambia" },
  { value: "georgia", label: "Georgia" },
  { value: "germany", label: "Germany" },
  { value: "ghana", label: "Ghana" },
  { value: "gibraltar", label: "Gibraltar" },
  { value: "greece", label: "Greece" },
  { value: "greenland", label: "Greenland" },
  { value: "grenada", label: "Grenada" },
  { value: "guadeloupe", label: "Guadeloupe" },
  { value: "guam", label: "Guam" },
  { value: "guatemala", label: "Guatemala" },
  { value: "guernsey", label: "Guernsey" },
  { value: "guinea", label: "Guinea" },
  { value: "guinea-bissau", label: "Guinea-Bissau" },
  { value: "guyana", label: "Guyana" },
  { value: "haiti", label: "Haiti" },
  {
    value: "heard-island-and-mcdonald-islands",
    label: "Heard Island and McDonald Islands",
  },
  { value: "holy-see", label: "Holy See" },
  { value: "honduras", label: "Honduras" },
  { value: "hong-kong", label: "Hong Kong" },
  { value: "hungary", label: "Hungary" },
  { value: "iceland", label: "Iceland" },
  { value: "india", label: "India" },
  { value: "indonesia", label: "Indonesia" },
  { value: "iran", label: "Iran (Islamic Republic of)" },
  { value: "iraq", label: "Iraq" },
  { value: "ireland", label: "Ireland" },
  { value: "isle-of-man", label: "Isle of Man" },
  { value: "israel", label: "Israel" },
  { value: "italy", label: "Italy" },
  { value: "jamaica", label: "Jamaica" },
  { value: "japan", label: "Japan" },
  { value: "jersey", label: "Jersey" },
  { value: "jordan", label: "Jordan" },
  { value: "kazakhstan", label: "Kazakhstan" },
  { value: "kenya", label: "Kenya" },
  { value: "kiribati", label: "Kiribati" },
  { value: "north-korea", label: "North Korea" },
  { value: "south-korea", label: "South Korea" },
  { value: "kuwait", label: "Kuwait" },
  { value: "kyrgyzstan", label: "Kyrgyzstan" },
  { value: "lao", label: "Lao People's Democratic Republic" },
  { value: "latvia", label: "Latvia" },
  { value: "lebanon", label: "Lebanon" },
  { value: "lesotho", label: "Lesotho" },
  { value: "liberia", label: "Liberia" },
  { value: "libya", label: "Libya" },
  { value: "liechtenstein", label: "Liechtenstein" },
  { value: "lithuania", label: "Lithuania" },
  { value: "luxembourg", label: "Luxembourg" },
  { value: "macao", label: "Macao" },
  { value: "madagascar", label: "Madagascar" },
  { value: "malawi", label: "Malawi" },
  { value: "malaysia", label: "Malaysia" },
  { value: "maldives", label: "Maldives" },
  { value: "mali", label: "Mali" },
  { value: "malta", label: "Malta" },
  { value: "marshall-islands", label: "Marshall Islands" },
  { value: "martinique", label: "Martinique" },
  { value: "mauritania", label: "Mauritania" },
  { value: "mauritius", label: "Mauritius" },
  { value: "mayotte", label: "Mayotte" },
  { value: "mexico", label: "Mexico" },
  { value: "micronesia", label: "Micronesia (Federated States of)" },
  { value: "moldova", label: "Moldova (the Republic of)" },
  { value: "monaco", label: "Monaco" },
  { value: "mongolia", label: "Mongolia" },
  { value: "montenegro", label: "Montenegro" },
  { value: "montserrat", label: "Montserrat" },
  { value: "morocco", label: "Morocco" },
  { value: "mozambique", label: "Mozambique" },
  { value: "myanmar", label: "Myanmar" },
  { value: "namibia", label: "Namibia" },
  { value: "nauru", label: "Nauru" },
  { value: "nepal", label: "Nepal" },
  { value: "netherlands", label: "Netherlands" },
  { value: "new-caledonia", label: "New Caledonia" },
  { value: "new-zealand", label: "New Zealand" },
  { value: "nicaragua", label: "Nicaragua" },
  { value: "niger", label: "Niger" },
  { value: "nigeria", label: "Nigeria" },
  { value: "niue", label: "Niue" },
  { value: "norfolk-island", label: "Norfolk Island" },
  { value: "northern-mariana-islands", label: "Northern Mariana Islands" },
  { value: "norway", label: "Norway" },
  { value: "oman", label: "Oman" },
  { value: "pakistan", label: "Pakistan" },
  { value: "palau", label: "Palau" },
  { value: "palestine", label: "Palestine, State of" },
  { value: "panama", label: "Panama" },
  { value: "papua-new-guinea", label: "Papua New Guinea" },
  { value: "paraguay", label: "Paraguay" },
  { value: "peru", label: "Peru" },
  { value: "philippines", label: "Philippines" },
  { value: "pitcairn", label: "Pitcairn" },
  { value: "poland", label: "Poland" },
  { value: "portugal", label: "Portugal" },
  { value: "puerto-rico", label: "Puerto Rico" },
  { value: "qatar", label: "Qatar" },
  { value: "north-macedonia", label: "Republic of North Macedonia" },
  { value: "romania", label: "Romania" },
  { value: "russia", label: "Russian Federation" },
  { value: "rwanda", label: "Rwanda" },
  { value: "reunion", label: "Réunion" },
  { value: "saint-barthelemy", label: "Saint Barthélemy" },
  {
    value: "saint-helena",
    label: "Saint Helena, Ascension and Tristan da Cunha",
  },
  { value: "saint-kitts-and-nevis", label: "Saint Kitts and Nevis" },
  { value: "saint-lucia", label: "Saint Lucia" },
  { value: "saint-martin", label: "Saint Martin (French part)" },
  { value: "saint-pierre-and-miquelon", label: "Saint Pierre and Miquelon" },
  {
    value: "saint-vincent-and-the-grenadines",
    label: "Saint Vincent and the Grenadines",
  },
  { value: "samoa", label: "Samoa" },
  { value: "san-marino", label: "San Marino" },
  { value: "sao-tome-and-principe", label: "Sao Tome and Principe" },
  { value: "saudi-arabia", label: "Saudi Arabia" },
  { value: "senegal", label: "Senegal" },
  { value: "serbia", label: "Serbia" },
  { value: "seychelles", label: "Seychelles" },
  { value: "sierra-leone", label: "Sierra Leone" },
  { value: "singapore", label: "Singapore" },
  { value: "sint-maarten", label: "Sint Maarten (Dutch part)" },
  { value: "slovakia", label: "Slovakia" },
  { value: "slovenia", label: "Slovenia" },
  { value: "solomon-islands", label: "Solomon Islands" },
  { value: "somalia", label: "Somalia" },
  { value: "south-africa", label: "South Africa" },
  {
    value: "south-georgia-and-south-sandwich-islands",
    label: "South Georgia and the South Sandwich Islands",
  },
  { value: "south-sudan", label: "South Sudan" },
  { value: "spain", label: "Spain" },
  { value: "sri-lanka", label: "Sri Lanka" },
  { value: "sudan", label: "Sudan" },
  { value: "suriname", label: "Suriname" },
  { value: "svalbard-and-jan-mayen", label: "Svalbard and Jan Mayen" },
  { value: "sweden", label: "Sweden" },
  { value: "switzerland", label: "Switzerland" },
  { value: "syria", label: "Syrian Arab Republic" },
  { value: "taiwan", label: "Taiwan" },
  { value: "tajikistan", label: "Tajikistan" },
  { value: "tanzania", label: "Tanzania, United Republic of" },
  { value: "thailand", label: "Thailand" },
  { value: "timor-leste", label: "Timor-Leste" },
  { value: "togo", label: "Togo" },
  { value: "tokelau", label: "Tokelau" },
  { value: "tonga", label: "Tonga" },
  { value: "trinidad-and-tobago", label: "Trinidad and Tobago" },
  { value: "tunisia", label: "Tunisia" },
  { value: "turkey", label: "Turkey" },
  { value: "turkmenistan", label: "Turkmenistan" },
  { value: "turks-and-caicos-islands", label: "Turks and Caicos Islands" },
  { value: "tuvalu", label: "Tuvalu" },
  { value: "uganda", label: "Uganda" },
  { value: "ukraine", label: "Ukraine" },
  { value: "united-arab-emirates", label: "United Arab Emirates" },
  {
    value: "united-kingdom",
    label: "United Kingdom of Great Britain and Northern Ireland",
  },
  {
    value: "united-states-minor-outlying-islands",
    label: "United States Minor Outlying Islands",
  },
  { value: "united-states", label: "United States of America" },
  { value: "uruguay", label: "Uruguay" },
  { value: "uzbekistan", label: "Uzbekistan" },
  { value: "vanuatu", label: "Vanuatu" },
  { value: "venezuela", label: "Venezuela" },
  { value: "vietnam", label: "Vietnam" },
  { value: "virgin-islands-british", label: "Virgin Islands (British)" },
  { value: "virgin-islands-us", label: "Virgin Islands (U.S.)" },
  { value: "wallis-and-futuna", label: "Wallis and Futuna" },
  { value: "yemen", label: "Yemen" },
  { value: "zambia", label: "Zambia" },
  { value: "zimbabwe", label: "Zimbabwe" },
];
